import { APCMStateBadge } from "./APCMStateBadge"
import type { PatientAPCMStateResponse } from "../types/apcm-ops.types"
import { parseApiTimestamp, timestampMs } from "@/lib/datetime"

function formatTimestamp(iso: string): string {
  const d = parseApiTimestamp(iso)
  if (!d) return iso
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  })
}

interface StateTimelineProps {
  states: PatientAPCMStateResponse[]
}

export function StateTimeline({ states }: StateTimelineProps) {
  // States come newest-first from the API
  const sorted = [...states].sort(
    (a, b) => timestampMs(b.created_at) - timestampMs(a.created_at)
  )

  return (
    <div className="relative space-y-0">
      {sorted.map((entry, i) => (
        <div key={entry.id} className="flex gap-3 pb-4">
          {/* Vertical line */}
          <div className="flex flex-col items-center">
            <div className="h-2.5 w-2.5 rounded-full bg-muted-foreground/40 mt-1.5 shrink-0" />
            {i < sorted.length - 1 && <div className="w-px flex-1 bg-border" />}
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0 -mt-0.5">
            <div className="flex items-center gap-2 flex-wrap">
              <APCMStateBadge state={entry.current_state} />
              <span className="text-xs text-muted-foreground font-mono">
                {formatTimestamp(entry.created_at)}
              </span>
            </div>
            <div className="mt-0.5 text-xs text-muted-foreground">
              {entry.agent_name && <span>Agent: {entry.agent_name}</span>}
              {entry.workflow_id && (
                <span className="ml-2 font-mono text-[10px]">
                  WF: {entry.workflow_id.slice(0, 8)}...
                </span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
